import { services } from '../services';
import { CategoryRecord } from '../utils/categoryUtils';

interface CategoryListApiResponse {
  status?: boolean;
  data?: CategoryRecord[];
}

interface CategoryCreateApiResponse {
  status?: boolean;
  data?: CategoryRecord;
  message?: string;
}

export const categoryActions = {
  getAssetCategories,
  createCategory,
};

function getAssetCategories(): Promise<{ data: CategoryRecord[] }> {
  return services
    .get<CategoryListApiResponse>(`/category/list?list=all&scope=asset`)
    .then((response) => {
      if (response.data?.data) {
        return { data: response.data.data };
      }
      return Promise.reject(new Error('Error fetching asset categories'));
    });
}

function createCategory(name: string): Promise<CategoryRecord> {
  return services.post<CategoryCreateApiResponse>(`/category/add`, { name }).then((response) => {
    const created = response.data?.data;
    if (created?._id) {
      return created;
    }
    return Promise.reject(new Error(response.data?.message || 'Failed to create category'));
  });
}
